/**
 * StepUpGateModal — shown when a protected action returns STEP_UP_REQUIRED.
 * Wraps the existing FounderStepUp panel in an overlay; on successful
 * verification the interrupted action is resumed automatically.
 */
import React from "react";
import { X, ShieldAlert } from "lucide-react";
import { FounderStepUp } from "./FounderStepUp";

export const isStepUpRequired = (e) =>
  e?.response?.status === 403 && e?.response?.data?.detail === "STEP_UP_REQUIRED";

export const StepUpGateModal = ({ opToken, userToken, onClose, onElevated }) => (
  <div className="fixed inset-0 z-[300] bg-black/85 flex items-center justify-center px-4 overflow-y-auto"
       data-testid="stepup-gate-modal" onClick={onClose}>
    <div className="w-full max-w-md bg-[#12110e] border border-[#2D2A26] my-8"
         onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#2D2A26]">
        <ShieldAlert size={14} className="text-[#E0A526]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#E4DFD3]">
          Founder verification required
        </span>
        <button onClick={onClose} data-testid="stepup-gate-close"
                className="ml-auto w-9 h-9 inline-flex items-center justify-center text-[#A39E93]">
          <X size={16} />
        </button>
      </div>
      <div className="p-4">
        <p className="text-[12px] text-[#A39E93] leading-relaxed mb-3">
          This action is protected. Verify your identity below — the action
          will continue automatically once verified.
        </p>
        <FounderStepUp opToken={opToken} userToken={userToken} onElevated={onElevated} />
      </div>
    </div>
  </div>
);

export default StepUpGateModal;
